export const SUPPORT_MONKEY_UID = "y4Evz9nRBMTgNp9syD3SRvuBO0u2";

export const SUPPORT_MONKEY_ASSOCIATE = {
  WerkerUid: SUPPORT_MONKEY_UID,
  WerkerFirstName: "WerkApp",
  WerkerLastName: "Support",
  WerkerProfilePicURL: "https://firebasestorage.googleapis.com/v0/b/werkapp-b5808.appspot.com/o/y4Evz9nRBMTgNp9syD3SRvuBO0u2%2FprofilePic%2F1760484874049.jpeg?alt=media&token=2d4470e1-cd54-4a0e-a20f-040eb26827a3"
};

export const isSupportMonkey = (uid: string): boolean => {
  return uid === SUPPORT_MONKEY_UID;
};

export const filterOutSupportMonkey = (associates: any[]): any[] => {
  return associates.filter(associate => 
    associate.WerkerUid !== SUPPORT_MONKEY_UID
  );
};

// Admin notification configuration
export const ADMIN_UIDS_FIELD = 'adminUIDs';
export const ADMIN_CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutes